export default __webpack_public_path__ + "static/media/a2-4-9.79e5bf70.jpg";